export default __webpack_public_path__ + "static/media/GIFMascota.453fe19f.gif";